<template>
  <div class="app-container">
    <!-- Hero Carousel Section -->
    <el-carousel
      height="100vh"
      indicator-position="bottom"
      arrow="always"
      class="hero-carousel"
    >
      <el-carousel-item v-for="(slide, index) in carouselSlides" :key="index">
        <div class="carousel-content">
          <img
            class="bg img"
            v-if="index == 0"
            src="~/assets/images/carousel-img-1.jpg"
          />
          <video
            class="bg myVideo"
            v-if="index == 1"
            autoplay
            loop
            preload
            muted
            src="~/assets/images/carousel-video-22.mp4"
          ></video>
          <img
            class="bg img"
            v-if="index == 2"
            src="~/assets/images/carousel-img-2.jpg"
          />
          <img
            class="bg img"
            v-if="index == 3"
            src="~/assets/images/carousel-img-3.jpg"
          />
          <div class="carousel-overlay">
            <h1 class="hero-title">
              {{ slide.title }}
            </h1>
            <h2 v-if="slide.subtitle" class="hero-subtitle">
              {{ slide.subtitle }}
            </h2>
            <!-- <div class="button-container">
              <button
                class="hero-button"
                v-for="(btn, btnIndex) in slide.btns"
                :keys="btnIndex"
                @click="navigateTo(btn.link)"
              >
                <span class="icon">⚙️</span> {{ btn.name }}
              </button>
            </div> -->
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <!-- Smart Manufacturing Section -->
    <section class="smart-manufacturing">
      <h2 class="section-title big">
        半导体基础系统供应商<br />
        遵守SEMI标准<br />
        产品数据
      </h2>

      <div class="stats-container">
        <div class="stat-item">
          <div class="stat-number">10+</div>
          <div class="stat-label">OEM 客户</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">100+</div>
          <div class="stat-label">运行设备</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">10+</div>
          <div class="stat-label">调试工具</div>
        </div>
      </div>
    </section>

    <!-- OEMs Section -->
    <section class="oems-section">
      <div class="content-container">
        <nuxt-link class="text-content" to="/page/OEM-Services">
          <h2 class="section-title">
            设备端：快速集成SEMI标准的方案，<br />按时交付设备
          </h2>
          <p>帮助设备快速集成SECS/GEM200，300功能</p>
          <el-button type="primary" class="learn-more-btn">了解更多</el-button>
        </nuxt-link>
        <div class="image-content flex-x-end">
          <img
            src="~/assets/images/equipment-connectivity.png"
            alt="OEM Manufacturing Equipment"
            class="section-image"
          />
        </div>
      </div>
    </section>

    <!-- Factories Section -->
    <section class="factories-section">
      <div class="content-container reverse">
        <nuxt-link class="text-content" to="/page/Factory-Services">
          <h2 class="section-title">
            工厂端： 将设备快速集成到工厂自动化生产制造中
          </h2>
          <p>帮助工厂端降低设备集成成本</p>
          <el-button type="primary" class="learn-more-btn">了解更多</el-button>
        </nuxt-link>
        <div class="image-content">
          <img
            src="~/assets/images/factory-connectivity.png"
            alt="Factory Integration"
            class="section-image"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
const carouselSlides = ref([
  {
    title: "Semiconductor Factories and OEMs basic module suppliers",
    // subtitle: "apc|m europe",
    // location: "April 9-10, 2023 | Prague, Czech Republic",
    image: "~/assets/images/carousel-img-1.jpg",
    btns: [{ name: "LEARN MORE", link: "/news-events/events/apcm-2025/" }],
  },
  {
    title:
      "Semiconductor production and manufacturing efficiency improvement expert",
    image: "~/assets/images/carousel-video-22.mp4",
    btns: [
      { name: "OEMs", link: "/products-services/oems/" },
      { name: "FACTORIES", link: "/products-services/factories/" },
    ],
  },
  {
    title: "Supporting the GEM300 to meet the requirements of the 12-inch Fab",
    // subtitle: "The latest cybersecurity standard",
    image: "~/assets/images/carousel-img-2.jpg",
    btns: [
      { name: "READ NOW", link: "/article/tell-me-more-whats-semi-e191/" },
    ],
  },
  {
    title: "SECS/GEM module with SEMI standards - DLink",
    image: "~/assets/images/carousel-img-3.jpg",
    btns: [
      {
        name: "READ NOW",
        link: "/article/chip-making-has-an-operating-system-problem/",
      },
    ],
  },
]);

const newsItems = ref([
  {
    title: "PEER Group exhibiting at apc|m Europe",
    image:
      "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/www.peergroup.com_%20%281%29-p8xaqivLkEzGei52ZKkvrHATen5BEA.png",
  },
  {
    title: "PEER Group recognized alongside SEMATECH",
    image:
      "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/www.peergroup.com_%20%281%29-p8xaqivLkEzGei52ZKkvrHATen5BEA.png",
  },
  {
    title: "PEER Group co-chairs with Semiconductor at FDA meeting",
    image:
      "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/www.peergroup.com_%20%281%29-p8xaqivLkEzGei52ZKkvrHATen5BEA.png",
  },
  {
    title: "We've released SCEPTER 4.x",
    image:
      "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/www.peergroup.com_%20%281%29-p8xaqivLkEzGei52ZKkvrHATen5BEA.png",
  },
  {
    title: "We've shipped CXCEEDME 1.x",
    image:
      "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/www.peergroup.com_%20%281%29-p8xaqivLkEzGei52ZKkvrHATen5BEA.png",
  },
  {
    title: "PEER supports Cybersecurity standard SEMI E187",
    image:
      "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/www.peergroup.com_%20%281%29-p8xaqivLkEzGei52ZKkvrHATen5BEA.png",
  },
]);

const contactForm = ref({
  name: "",
  email: "",
  message: "",
});
</script>

<style lang="scss" scoped>
.app-container {
  width: 100%;
  overflow-x: hidden;
}

.section-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-align: left;
  &.white {
    color: white;
  }

  &.big {
    font-size: 60px;
    text-align: center;
  }
}

.section-title.centered {
  text-align: center;
}

.learn-more-btn {
  margin-top: 1rem;
  a {
    color: white !important;
  }
}

/* Hero Carousel Styles */
.hero-carousel {
  width: 100%;
}

.carousel-content {
  height: calc(100% - 70px);
  background-size: cover;
  background-position: center;
  position: relative;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 70px;
  box-sizing: border-box;
  .bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;
    &.img {
      filter: brightness(0.5);
    }
  }
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 2rem;
}

.hero-title {
  font-size: 3rem;
  font-weight: bold;
  text-align: center;
  max-width: $maxWidth;
  margin-bottom: 1rem;
  line-height: 1.2;
  color: white;
}
.hero-subtitle {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: white;
  text-align: center;
}
.button-container {
  margin-top: 3rem;
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
}

.hero-button {
  background-color: transparent;
  border: 1px solid white;
  color: white;
  padding: 0.75rem 2rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: background-color 0.3s;
}

.hero-button:hover {
  background-color: #1989fa;
  border-color: #1989fa;
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2rem;
  }

  .button-container {
    flex-direction: column;
  }
}

@media (min-width: $maxWidth) {
  .hero-title {
    font-size: 4rem;
  }
}

.carousel-text p {
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.carousel-text .location {
  font-size: 1rem;
  margin-bottom: 2rem;
}

/* Smart Manufacturing Section */
.smart-manufacturing {
  padding: 5rem 2rem;
  text-align: center;
}

.stats-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
  margin-top: 3rem;
}

.stat-item {
  flex: 1;
  min-width: 200px;
  max-width: 250px;
  text-align: center;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1989fa;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 1rem;
}

/* OEMs and Factories Sections */
.oems-section,
.factories-section {
  padding: 5rem 2rem;
  background-color: #f5f7fa;
}

.factories-section {
  background-color: white;
}

.content-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: $maxWidth;
  margin: 0 auto;
  gap: 2rem;
}

.content-container.reverse {
  flex-direction: row-reverse;
}

.text-content {
  flex: 1;
  min-width: 300px;
  color: #333;
}

.image-content {
  flex: 1;
  min-width: 300px;
  display: flex;
}

.section-image {
  max-width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: contain;
}

.news-container {
  max-width: $maxWidth;
  margin: 0 auto;
}

.news-item-col {
  margin-bottom: 20px;
}

.news-item {
  height: 250px;
  background-size: cover;
  background-position: center;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}

.news-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1rem;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  color: white;
}

.news-overlay h3 {
  font-size: 1.2rem;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .section-title {
    font-size: 1.5rem;
  }

  .carousel-text h1 {
    font-size: 1.8rem;
  }

  .carousel-text .subtitle {
    font-size: 1.5rem;
  }

  .stat-item {
    min-width: 150px;
  }
}

@media (max-width: 480px) {
  .carousel-text h1 {
    font-size: 1.5rem;
  }

  .carousel-text .subtitle {
    font-size: 1.2rem;
  }

  .stats-container {
    flex-direction: column;
    align-items: center;
  }

  .stat-item {
    width: 100%;
    max-width: 100%;
  }
}
</style>
